import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import datos from 'src/assets/datos-curriculum2.json';
import { Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CurriculumService {
  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  private curriculum: any = null;
  private documentId: string | null = null;

  private lastSearchPayload: any = null;
  private lastDocumentNumber: string | null = null;

  private lastJobOffersSearchByCvUiState: any = null;
  private readonly lastJobOffersSearchByCvUiStateStorageKey = 'lastJobOffersSearchByCvUiState';

  backToHome() {
    this.router.navigate([`/curriculum`]);
  }

  backToDetailCV() {
    this.router.navigate([`/curriculum/curriculum-detail`]);
  }

   backToSearchCV() {
    this.router.navigate([`/curriculum/curriculum-search`]);
  }


  /** Simula llamadas HTTP, usando RxJS */
  sendCVMock(
    file: File,
    interests?: string,
    preferences?: string,
    restrictions?: string,
    additionalInfo?: string,
    docType?: string,
    documentId?: string
  ): Observable<any> {
    return of(datos);
  }

  getCVByDocumentMock(documentId: string): Observable<any> {
    return of(datos);
  }

  saveCVMock(documentId: string, payload: any): Observable<any> {
    return of(datos);
  }

  downloadCVMock(documentId: string): Observable<any> {
    return of(datos);
  }

  sendCV(payload: any, documentNumber?: string) {
    const url = `${environment.urlCore}/jobseeker/${documentNumber}/cv/generate`;
    return this.http.post(url, payload, {
      headers: { 'Content-Type': 'application/json' },
      observe: 'response',
    });
  }

  getCVByDocument(documentId: string): Observable<any> {
    const url = `${environment.urlCore}/jobseeker/${documentId}/cv`;
    return this.http.get<any>(url);
  }

  updateOccupation(documentId: string, payload: any): Observable<any> {
    const url = `${environment.urlCore}/jobseeker/${documentId}/regenerate-occupations`;
    return this.http.post<any>(url, payload);
  }

  continueCV(documentId: string, payload: any): Observable<any> {
    const url = `${environment.urlCore}/jobseeker/${documentId}/cv/augment`;
    return this.http.post(url, payload, {
      headers: { 'Content-Type': 'application/json' },
      observe: 'response',
    });
  }

  saveCV(documentId: string, payload: any): Observable<any> {
    const url = `${environment.urlCore}/jobseeker/${documentId}/cv`;
    return this.http.put(url, payload);
  }

  downloadCV(nif: string, full: boolean): Observable<Blob> {
    const url = `${environment.urlCore}/jobseeker/${nif}/cv/standard`;
    return this.http.get(url, {
      params: { full: String(full) },
      responseType: 'blob'
    });
  }

  downloadCVOriginal(documentId: string): Observable<Blob> {
    const url = `${environment.urlCore}/jobseeker/${documentId}/cv/original`;
    return this.http.get(url, {
      responseType: 'blob'
    });
  }

  searchJobseeker(searchConditions: string): Observable<HttpResponse<any>> {
    const url = `${environment.urlCore}/jobseeker/search`;
    return this.http.post<any>(url, searchConditions, { observe: 'response' });
  }

 /*  searchJobOffers(documentId: string, payload: any): Observable<any> {
    const url = `${environment.urlCore}/jobseeker/${documentId}/searchjoboffers`;
    return this.http.get(url, payload);
  } */

  searchJobOffers(documentNumber: string, payload: any) {
    const url = `${environment.urlCore}/jobseeker/${documentNumber}/searchjoboffers`;
    return this.http.post(url, payload, {
      headers: { 'Content-Type': 'application/json' },
      observe: 'response',
    });
  } 

  deleteCV(document: string): Observable<void> {
    const url = `${environment.urlCore}/jobseeker/${document}/cv`;
    return this.http.delete<void>(url);
  }

  checkDniCv(documentNumber: string): Observable<{ hasCv: boolean }> {
    return this.getCVByDocument(documentNumber).pipe(
        map(() => ({ hasCv: true })), // Si devuelve 200, tiene CV
        catchError((err: HttpErrorResponse) => {
            if (err.status === 404) {
                // No existe CV asociado
                return of({ hasCv: false });
            }
            // Otros errores validan
            return of({ hasCv: false });
        })
    );
  }

   getCNO(code: string): Observable<any> {
    const url = `${environment.urlCore}/joboccupations/${code}`;
    return this.http.get<any>(url);
  }

  searchJobOffersByCv(documentNumber: string, payload: any) {
    return this.searchJobOffers(documentNumber, payload);
  }

  saveLastSearch(documentNumber: string, payload: any) {
    this.lastDocumentNumber = documentNumber;
    this.lastSearchPayload = payload;
  }

  getLastSearch() {
    return {
        documentNumber: this.lastDocumentNumber,
        payload: this.lastSearchPayload
    };
  }

  saveLastJobOffersSearchByCvUiState(state: any): void {
    this.lastJobOffersSearchByCvUiState = state;
    try {
      localStorage.setItem(this.lastJobOffersSearchByCvUiStateStorageKey, JSON.stringify(state ?? null));
    } catch {
      // ignore storage errors (quota/private mode)
    }
  }

  getLastJobOffersSearchByCvUiState(): any {
    if (this.lastJobOffersSearchByCvUiState) return this.lastJobOffersSearchByCvUiState;
    try {
      const raw = localStorage.getItem(this.lastJobOffersSearchByCvUiStateStorageKey);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }


  /** Datos en sesión */
  setCurriculum(data: any): void {
    this.curriculum = data;
    localStorage.setItem('cv', JSON.stringify(data));
  }

  getCurriculum(): any {
    return this.curriculum || JSON.parse(localStorage.getItem('cv') ?? '');
  }

  setDocumentId(id: string) {
    this.documentId = id;
    localStorage.setItem('documentId', id);
  }

  getDocumentId(): string | null {
    return this.documentId || localStorage.getItem('documentId');
  }
}
